// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__3Nv-E","welcome":"Landing_welcome__vs8TL","avatar":"Landing_avatar__39fD-"};